module.exports = __webpack_public_path__ + "static/media/dashboard-simple-flow_ro.df847e58.gif";